import { C } from '../theme'
import { useContent } from '../content/ContentContext'

export function ValuesStrip() {
  const values = useContent().home.values ?? []
  if (values.length === 0) return null

  return (
    <section style={{ background: C.blue, color: '#eaf1fb' }}>
      <div className="stack" style={{ maxWidth: 1180, margin: '0 auto', display: 'grid', gridTemplateColumns: `repeat(${values.length},1fr)` }}>
        {values.map((v, i) => (
          <div
            key={v.id ?? v.title ?? i}
            style={{
              padding: '32px 40px', textAlign: 'center',
              borderRight: i < values.length - 1 ? '1px solid rgba(234,241,251,.18)' : undefined,
            }}
          >
            <div style={{ fontFamily: "'Spectral',serif", fontSize: 29, marginBottom: 6, color: '#fff' }}>{v.title}</div>
            <div style={{ fontSize: 14, color: 'rgba(234,241,251,.8)' }}>{v.text}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
